<section class="pt-6 pb-12" id="servicesSection" *transloco="let t; prefix: 'property-details.property-services'">
  <h2 class="text-[1.75rem] font-semibold text-black mb-2">
    {{ t("header") }}
  </h2>
  <p class="mb-8">{{ t("description") }}</p>

  <div
  class="flex flex-row overflow-x-auto md:overflow-x-hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 scrollbar-hidden">

  <app-service-card *ngFor="let service of (this.isAuctioned ? auctionServices : defaultServices)" class="md:flex-1" 
      [title]="t(service.title)"
      [isSold]="isSold"
      [subtitle]="t(service.subtitle)" [imagePath]="service.imagePath"
      [ctaTitle]="t(service.ctaTitle)" [propertyCode]="propertyCode ?? ''" 
      [serviceType]="service.serviceType" 
      [isServicePage]="false"
      [isAuctioned]="false" />    
      <!--I set isAuctioned to false as default the service card makes the button
       disabled if it is auctionated which does not help on this specific situation 
       because we handle the services conditionally so every time we want to be enabled -->
  </div>
</section>